export enum InfoPanelTypes {
  INFORMATION = 'information',
  WARNING = 'warning',
}
